module.exports = __webpack_public_path__ + "img/logo_aglt.7f3945ce.png";